import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import Waitlist from "./Waitlist";
import LoginForm from "../pages/auth/pages/login";
import RegisterForm from "../pages/auth/pages/register";
import PasswordUpdateForm from "../pages/auth/pages/forget_pass";

//Third party

// User Import

// Admin Import

function Pages() {
  return (
    <div>
      <Routes>
        {/* Third Party Route */}

        {/* Main website routes */}
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/waitlist" element={<Waitlist />} />
        <Route path="/auth/login" element={<LoginForm/>} />
        <Route path="/auth/register" element={<RegisterForm/>} />
        <Route path="/auth/update-password" element={<PasswordUpdateForm/>} />
        {/* User Pages*/}

        {/* Admin Pages */}
      </Routes>
    </div>
  );
}

export default Pages;
